import * as React from 'react';
import { Routes, Route } from 'react-router-dom';
import AccreditationVersionsProvider from './context';
import AccreditationVersionsList from './List';
import Standards from './Standards';
import ReleaseVersion from './Release';

const AccreditationVersions: React.FC = () => {
  return (
    <AccreditationVersionsProvider>
      <Routes>
        <Route
          path=''
          element={<AccreditationVersionsList />}
        />
        <Route
          path=':versionId/release'
          element={<ReleaseVersion />}
        />
        <Route
          path=':versionId/standards/*'
          element={<Standards />}
        />
      </Routes>
    </AccreditationVersionsProvider>
  );
};

export default AccreditationVersions;
